<template>
    <div id="fullscreen" ref="nsts">
        <transition name="nstsimg">
            <div v-show="isShow" id="nsts">
                <!-- TODO: 需要翻译 -->
                <!-- 页面等待，页面软广告 -->
                <div class="loading">
                    <div class="slogen">
                        <img src="~@assets/images/login/apy_slogen.png" alt="slogen" />
                        <p>威视安培云，你的智慧选择</p>
                    </div>
                </div>
                <el-button
                    v-if="showCloseBtn"
                    id="btnclose"
                    class="exit"
                    type="danger"
                    size="mini"
                    icon="el-icon-close"
                    round
                    :title="$t('c.close')"
                    @click="closeFullScreen"
                />

                <!-- 承载图像全屏显示的容器 -->
                <iframe
                    id="myframe"
                    class="nsts-wrapper"
                    frameborder="0"
                    allowfullscreen=true
                    :src="src"
                >
                </iframe>
            </div>
        </transition>
    </div>
</template>

<script>
import api from '@/api'
export default {
    name: 'FullScreen', // 图像全屏
    props: {
        isShow: {
            type: Boolean,
            default: false
        },
        src: {
            type: String,
            default: ''
        },
        showCloseBtn: {
            type: Boolean,
            default: true,
        }
    },
    data() {
        return {
            isLoaded: false
        }
    },
    watch: {
        isShow(val) {
            if (val) {
                $(window).on('resize.full', e => {
                    if (!this.checkFull()) {
                        // 通过ESC关闭全屏时，向iframe发送消息
                        document.getElementById('myframe').contentWindow.postMessage({
                            type: 'clearToken'
                        }, api.imagePanoramicHost)
                        this.closeFullScreenOnResize()
                    } else {
                        let frameDom = document.getElementById('myframe')
                        frameDom && frameDom.focus()
                    }
                })
            } else {
                $(window).off('resize.full')
            }
        }
    },
    mounted() {
        this.docNsts = this.$refs.nsts
        const getFullScreenType = () => {
            if (this.docNsts.requestFullscreen) {
                return ['requestFullscreen', 'exitFullscreen']
            } else if (this.docNsts.msRequestFullscreen) {
                return ['msRequestFullscreen', 'msExitFullscreen']
            } else if (this.docNsts.mozRequestFullScreen) {
                return ['mozRequestFullScreen', 'mozCancelFullScreen']
            } else if (this.docNsts.webkitRequestFullScreen) {
                return ['webkitRequestFullScreen', 'webkitCancelFullScreen']
            }
        }
        this.fullScreenType = getFullScreenType()

        this.onMessageFromPanoramic = ({ data }) => {
            console.log('接收来自图像全景台的消息', data)
            if (data.type === 'reLogin') {
                this.closeFullScreen()
                this.$message.info('请重新登录')
                this.$router.push({name: 'login'})
                return
            }
            if (data.type === 'closePage') {
                this.closeFullScreen()
            }
            if (data.type === 'skipPage') {
                this.closeFullScreen()
                let { routeObj } = data
                this.$router.push(routeObj)
            }
        }
        window.addEventListener('message', this.onMessageFromPanoramic, false)
    },
    beforeDestroy() {
        $(window).off('resize.full')
        window.removeEventListener('message', this.onMessageFromPanoramic, false)
    },
    methods: {
        closeFullScreenOnResize() {
            this.$emit('changeIsShow', false)
        },
        closeFullScreen() {
            this.$emit('changeIsShow', false)
            document[this.fullScreenType[1]]()
        },
        fullScreen() {
            this.docNsts[this.fullScreenType[0]]()
        },
        checkFull() {
            let isFull = window.fullScreen || document.webkitIsFullScreen || document.msFullscreenEnabled
            return !!isFull
        }
    }
}
</script>

<style lang="scss">
#nsts {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #f5f5f5;
    z-index: 3000;

    .loading {
        position: absolute;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #f5f5f5;
        pointer-events: none;
        z-index: -1;

        .slogen {
            text-align: center;
        }

        p {
            margin-top: 15px;
            font-size: 24px;
            color: #444;
            animation: nuctech 8s infinite alternate;
        }

        img {
            width: 200px;
        }
    }

    .exit {
        position: absolute;
        top: 10px;
        right: 10px;
        z-index: 1000;
    }

    .nsts-wrapper {
        width: 100%;
        height: 100%;
        z-index: 100;
    }
}

@keyframes nuctech {
    0% {
        transform: scale(1);
    }
    100% {
        transform: scale(1.2);
    }
}
</style>
